<template>
  <div v-loading="loading">
    <el-button type="primary" @click="addShareFunc">添加</el-button>

    <el-table
      class="share-table"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="share_list_id"
        label="商品id"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goods_type"
        label="分类"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goods_title"
        label="标题"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="reward_type"
        label="获利类型"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        label="添加时间"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="update_time"
        label="修改时间"
        width="150"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="editShareGoods(scope.row)" type="text" size="small"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        class="paginate"
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

     <addGood v-if="is_add" :addShareStatus="addShareStatus"  @close="closeAdd" style="margin:0 auto;"></addGood>
     <editGood v-if="is_edit" :editShareStatus="editShareStatus" :toGoodSetting="goodsInfo" @close="closeEdit"></editGood>
  </div>
</template>

<script>
import ShareApi from "@/api/sharepolite.js";
// import goodsTable from "./addGoods/selectInfo.vue";
import addGood from "./addGoods/index.vue";
import editGood from "./editGoods/editGoods.vue";
export default {
  components: {
    // goodsTable,
    addGood,
    editGood,
  },
  data() {
    return {
      dialogEditStatus:false,
      addShareStatus: false,
      // 修改页面参数
      editShareStatus: false,
      addShareStatus: false,
      // 显示修改页面
      is_edit:false,
      is_add:false,
      editGoodsId: 0,
      editGoodsTitle: "",
      editGoodsType: "",
      goodsInfo:{
        setting:{}
      },
      loading: true,
      goodsId: 0,
      goodsTitle: "",
      goodsType: "",
      tableData: [],
      total: 1,
      curPage: 0,
      pageSize: 0,
      // 添加商品页面
      addNoShareGoodsList: [],
    };
  },
  methods: {
    // 添加分享商品
    addShareFunc() {
      this.is_add = true;
      this.addShareStatus = true;
    },

    // 子组件传来修改标题内容(修改diag标题和内容)
    changeTitle(e) {
      this.$data.addDialog.title = e.title;
      this.$data.dialogContent = e.content;
    },

    // 获取分享商品
    getsharegoodsList() {
      ShareApi.getsharegoodsList("", false).then((res) => {
        this.tableData = res.data.data.data;
        this.loading = false;
        this.total = res.data.data.total;
        this.pageSize = res.data.data.per_page;
      });
    },

    // 单一分享商品属性修改
    editShareGoods(e) {
      this.editShareStatus = true;
      this.is_edit =true;
     
      this.goodsInfo.goods_title = e.goods_title;
      this.goodsInfo.goods_type = e.goods_type;
      this.goodsInfo.share_list_id = e.share_list_id;
      this.goodsInfo.setting = JSON.parse(e.setting);
    },

    // 获取单个分享商品信息
    // getShareGoodsInfo() {
    //   let params = { id: this.goodsInfo.share_list_id };
    //   ShareApi.getsharegoods(params, false).then((res) => {
    //     let param = JSON.parse(res.data.data);
        
    //     this.editGoodsStatus = param.status;
    //     this.editGoodsModel = param.reward_model;
    //     this.editShareRecommend = param.is_share;
    //     this.editShareReWardType = param.reward_type;
    //     this.editShareReWardTotal = param.reward_total;
    //     this.editShareMinReWard = param.reward_min;
    //     this.editShareMaxReWard = param.reward_max;
    //     // this.editShareEffectiveTime = param.effective_time;
    //   });
    // },

    // 添加分享商品信息
    addShareGoodsInfo() {
      let params = { type: "all" };
      ShareApi.selectNoShareGoods(params, true).then((res) => {
        console.log(res.data.data);
        this.addNoShareGoodsList = res.data.data;
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getsharerecords();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getsharerecords();
    },

    /*关闭编辑*/
    closeEdit(e){
      this.editShareStatus=false;
      this.is_edit = false;
      if(e.type=='success'){
        this.getsharegoodsList();
      }
    },
     /*关闭添加*/
    closeAdd(e){
      this.addShareStatus=false;
      this.is_add = false;
      if(e.type=='success'){
      console.log(e)
        // this.getsharegoodsList();
      }
    },
  },
  created() {
    this.getsharegoodsList();
  },
};
</script>

<style lang="scss" scoped>
.paginate {
  margin-top: 4em;
}

.share-table {
  margin-top: 2em;
}
</style>>



// WEBPACK FOOTER //
// src/components/sharepolite/shareset.vue